import { getPercent } from 'ChannelSummary/utils'
import classNames from 'classnames'
import InfoElement from 'components/InfoElement'
import type { DetailsData } from 'data/types'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { label } from 'styles'
import { getDifferenceWithPrecision } from 'utils'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'

import useStyles from './useStyles'

export interface TrafficDetailsProps {
  data: DetailsData
}

function TrafficDetails({ data }: TrafficDetailsProps) {
  const { t: translate } = useTranslation()
  const classes = useStyles()
  const showClubCard = (data.clubShareCurrent || 0) > 0 || (data.clubSharePercent || 0) > 0 || (data.clubCardsCurrent || 0) > 0

  if (!showClubCard) return null

  return (
    <>
      <Divider />
      <Box padding="1.4rem 1.6rem 1.2rem 0.8rem" display="flex">
        <Grid container>
          <Grid display="flex" flexDirection="column" justifyContent="center" item xs={2} textAlign="center">
            <div className={classNames('fm fm-traffic', classes.icon)} />
            <Box color={label}>{translate('revenue.details.traffic')}</Box>
          </Grid>
          <Grid item xs={5} display="flex" alignItems="baseline">
            <Box ml={1}>
              <Box display="flex" justifyContent="space-between" alignItems="baseline">
                {translate('revenue.stats.avgNew')}:
                <Box display="inline" className={classes.value} ml={1}>
                  {data.trafficPerStoreCurrentNew}
                </Box>
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="baseline">
                {translate('revenue.stats.quantityNew')}:
                <Box display="inline" className={classes.value} ml={1}>
                  {data.storesNewCurrent}
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={4}>
            <Grid container alignItems="baseline">
              <Grid item xs={4}>
                {translate('revenue.stats.avgL4L')}:
              </Grid>
              <Grid item xs={3} className={classes.value} textAlign="right">
                {data.trafficPerStoreCurrentL4L}
              </Grid>
              <Grid item xs={2} ml={0.5}>
                <InfoElement
                  className={classes.percentInfo}
                  percentDifference={getDifferenceWithPrecision({
                    handleNullCase: true,
                    number: data.trafficPerStorePercentL4L,
                    precision: 0,
                    translate,
                  })}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="baseline">
              <Grid item xs={4}>
                {translate('revenue.stats.quantityL4L')}:
              </Grid>
              <Grid item xs={3} className={classes.value} textAlign="right">
                {data.storesCurrentL4L}
              </Grid>
            </Grid>
          </Grid>
          {data.conversionCurrentNECom !== undefined && (
            <Grid item xs={1} display="flex" alignItems="center">
              <Box className={classes.conversion} display="flex" alignItems="center">
                <i className={classNames('fm fm-conversion', classes.conversionIcon)} />
                {getPercent(data.conversionCurrentNECom, translate)}
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  )
}

export default memo<TrafficDetailsProps>(TrafficDetails)
